import styled from 'styled-components'

import Logo from '../Logo'
import FormSelect from '../form/FormSelect'
import breakpoints from '../../theme/breakpoints'

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 20px;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid black;
  justify-content: flex-end;
`

export const SLogo = styled(Logo)`
  max-width: 136px;

  ${breakpoints.up('tablet')} {
    max-width: 170px;
  }

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const LanguageSelector = styled(FormSelect)`
  select {
    ${(p) => p.theme.fonts.BBRegular}
    font-size: 12px;
    text-transform: uppercase;
    text-align: right;
    border: none;
    padding: 12px 40px 12px 12px;
  }
`
